import type { FieldValues } from 'react-hook-form';

import { PHONE_MASK_OPTIONS, trimPhone } from '../../../../utils/format/phone';
import RhfTextField, {
  type RhfTextFieldProps,
} from '../RhfTextField/RhfTextField';

type PresetProps =
  | 'mask'
  | 'setValueAs'
  | 'type'
  | 'inputMode'
  | 'autoComplete'
  | 'multiline';

export type RhfPhoneFieldProps<T extends FieldValues> = Omit<
  RhfTextFieldProps<T>,
  PresetProps
>;

export default function RhfPhoneField<T extends FieldValues>(
  props: RhfPhoneFieldProps<T>
) {
  return (
    <RhfTextField<T>
      type='tel'
      inputMode='tel'
      autoComplete='tel'
      mask={PHONE_MASK_OPTIONS}
      setValueAs={trimPhone}
      {...props}
    />
  );
}
